/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { TextCellModelExport } from "./TextCellModelExport";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var TextHeaderCellModelExport = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TextHeaderCellModelExport, _super);
    function TextHeaderCellModelExport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextHeaderCellModelExport.prototype.get_ac = function () {
        return "TextHeaderCell";
    };
    TextHeaderCellModelExport.prototype.ad = function (a) {
        _super.prototype.ad.call(this, a);
    };
    TextHeaderCellModelExport.$t = markType(TextHeaderCellModelExport, 'TextHeaderCellModelExport', TextCellModelExport.$);
    return TextHeaderCellModelExport;
}(TextCellModelExport));
export { TextHeaderCellModelExport };
//# sourceMappingURL=TextHeaderCellModelExport.js.map
